/**
 * checks whether the given object is a real string
 * @param str the object to be checked
 * @returns true if and only if the given object is string with length greater than zero
 */
export function isString(str: string | unknown): str is string {
  return typeof str === 'string' && str.length > 0
}
